import {CustomerProfileCard} from '../../../api/entity/customer-profile-cards';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CustomerCardsService} from '../../../api/service/customer-cards.service';

const STATUS_ACTIVE = 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.ACTIVE';
const STATUS_INACTIVE = 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.INACTIVE';
const STATUS_SET = 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.SET';
const STATUS_ACTIVE_CLASS = 'card-active';
const STATUS_INACTIVE_CLASS = 'card-inactive';
const STATUS_SET_CLASS = 'card-set';
const CARD_STATUS_ACTIVE_ID = 3;
const CARD_STATUS_INACTIVE_ID = 4;

@Component({
    selector: 'tfl-profile-detail-card',
    template: require('./card.template.html')
})
export class ProfileCardComponent implements OnInit {

    @Input() card: CustomerProfileCard;
    @Input('isBlocked') isBlocked:boolean = false;
    @Output('statusChange') statusChange: EventEmitter<any> = new EventEmitter();
    private statusText: string;
    private statusClass: string;
    private isActive: boolean;
    oppositeStatusText: string;
    oppositeStatusClass: string;
    isSet: boolean = false;

    constructor(private _customerCardService: CustomerCardsService) {
    }

    ngOnInit(): void {
        switch (this.card.status.name) {
            case 'active':
                this.statusText = STATUS_ACTIVE;
                this.statusClass = STATUS_ACTIVE_CLASS;
                this.oppositeStatusText = STATUS_INACTIVE;
                this.oppositeStatusClass = STATUS_INACTIVE_CLASS;
                this.isActive = true;
                break;
            case 'inactive':
                this.statusText = STATUS_INACTIVE;
                this.statusClass = STATUS_INACTIVE_CLASS;
                this.oppositeStatusText = STATUS_ACTIVE;
                this.oppositeStatusClass = STATUS_ACTIVE_CLASS;
                this.isActive = false;
                break;
            case 'set':
                this.statusText = STATUS_SET;
                this.statusClass = STATUS_SET_CLASS;
                this.isActive = false;
                this.isSet = true;
                break;
            default:
                this.statusText = undefined;
                this.statusClass = undefined;
                this.isActive = undefined;
        }

    }

    public getStatusText(): string {
        return this.statusText;
    }

    public getStatusClass(): string {
        return this.statusClass;
    }

    public active(): boolean {
        return this.isActive;
    }

    changeStatus() {
        if (this.statusText === 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.SET') {
            return;
        }
        switch (this.card.status.id) {
            case CARD_STATUS_ACTIVE_ID:
                this.card.status.id = CARD_STATUS_INACTIVE_ID;
                break;
            case CARD_STATUS_INACTIVE_ID:
                this.card.status.id = CARD_STATUS_ACTIVE_ID;
                break;
        }
        this._customerCardService.changeCardState(this.card.id, this.card.status.id)
            .subscribe(data => {
                this.statusChange.emit();
            });
    }
}















// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/cards/card/card.component.ts